import type { DiscoveredRouteModule } from '@/router/generator/types';

const ServiceUnavailableView = () => import('@/views/error-pages/ServiceUnavailableView.vue');
export const NAME_SERVICE_UNAVAILABLE = 'ServiceUnavailable';
export const PATH_SERVICE_UNAVAILABLE = '/service-unavailable';

export const route: DiscoveredRouteModule = {
  id: 'root.error.service_unavailable',
  scope: 'root',
  name: NAME_SERVICE_UNAVAILABLE,
  path: PATH_SERVICE_UNAVAILABLE,
  component: ServiceUnavailableView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


